// LogoutButton.jsx
import { useNavigate } from "react-router-dom";

export default function LogoutButton() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/driver/login");
  };

  return (
    <button
      onClick={handleLogout}
      className="fixed top-4 right-4 px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors"
    >
      Logout
    </button>
  );
}
